var render, staticRenderFns
import script from "./LogListMixin.vue?vue&type=script&lang=js"
export * from "./LogListMixin.vue?vue&type=script&lang=js"
import style0 from "./LogListMixin.vue?vue&type=style&index=0&id=708587cb&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports